import React from 'react'
import { useSelector } from 'react-redux'

import { selectIsGrowthbookReady } from 'root-redux/selects/common'

import { TPageProps } from 'models/common.model'

import { AyahGenderV2 } from './AyahGenderV2/AyahGenderV2'

export const AyahGenderFactory: React.FC<TPageProps> = (props) => {
  const isGrowthbookReady = useSelector(selectIsGrowthbookReady)

  if (!isGrowthbookReady) return null

  return <AyahGenderV2 {...props} isFirstPage />
}
